export default "__VITE_ASSET__CJB2f7T5__"